import { render, staticRenderFns } from "./request-header.vue?vue&type=template&id=2c90d796&scoped=true"
import script from "./request-header.vue?vue&type=script&lang=ts"
export * from "./request-header.vue?vue&type=script&lang=ts"
import style0 from "./request-header.vue?vue&type=style&index=0&id=2c90d796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90d796",
  null
  
)

export default component.exports